import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { getPortalSdkUrl, isSharePath } from "@jari-tools/shared";
import { loadPortalSdk } from "./portal-sdk";
import { App } from "./App";
import { SharePlayApp } from "./components/SharePlay";
import "./tool.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

function renderApp() {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

if (isSharePath()) {
  createRoot(root).render(
    <StrictMode>
      <SharePlayApp />
    </StrictMode>,
  );
} else {
  loadPortalSdk(getPortalSdkUrl())
    .catch(() => {})
    .finally(renderApp);
}
